/**
 * Graphs of the advertisement (asking-price) series, in display order (consumers contract §1), shared by
 * ListingIndexSection.vue and the dashboards' graph requests. The last one is the v0 series, kept for one
 * year after v1 activation as "previous method (to 2023)". titleKey and unitKey are translation keys.
 */
export const LISTING_GRAPHS = [
    { key: "asking_index", titleKey: "dashboard:asking_index", kind: "line", unit: "", decimals: 1 },
    { key: "std_asking_price_m2", titleKey: "dashboard:std_asking_price_m2", kind: "line", unit: "€/m²", decimals: 0 },
    { key: "advertisement_count", titleKey: "dashboard:new_listings", kind: "bar", unit: "", decimals: 0 },
    { key: "asking_premium", titleKey: "dashboard:asking_premium", kind: "line", unit: "%", decimals: 1 },
    { key: "tom_median_days", titleKey: "dashboard:tom_median_days", kind: "line", unitKey: "dashboard:unit:days", decimals: 0 },
    { key: "months_of_supply", titleKey: "dashboard:months_of_supply", kind: "line", unitKey: "dashboard:unit:months", decimals: 1 },
    { key: "cut_share", titleKey: "dashboard:cut_share", kind: "line", unit: "%", decimals: 1 },
    {
        key: "med_selling_price_m2_advertisement",
        titleKey: "dashboard:asking_price_previous_method",
        kind: "line",
        unit: "€/m²",
        decimals: 0,
        previousMethod: true,
    },
];

/** Request parameters of the asking-price graphs ({key: 1, ...}). */
export function listingGraphParams() {
    const params = {};
    LISTING_GRAPHS.forEach(graph => { params[graph.key] = 1; });
    return params;
}
